import React, { Component } from "react";

import { Field } from "@atlaskit/form";
import FieldText from "@atlaskit/field-text";

import { isValidNumber } from "../../utils/consts";

export default class ApplyCardRentField extends Component {
  isValidRent = () => isValidNumber(this.props.value);

  render() {
    return (
      <Field
        className="rentOffer-container"
        id="rentOffer-container"
        isRequired={true}
        label="Rental Offer"
        helperText={this.props.helperText}
        isInvalid={!this.isValidRent}
      >
        <FieldText
          autoComplete="off"
          className="apply-card-form__field-text"
          name="rentOffer"
          id="rentOffer"
          onChange={this.props.onChange}
          value={this.props.value}
          placeholder={this.props.placeholder}
          shouldFitContainer={true}
        />
      </Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ApplyCardRentField/ApplyCardRentField.js